// Sales page data fetch — calls the moreece-sales-shopify Lambda.
//
// The Lambda validates the PIN against moreece `access_codes`, then runs
// three Athena queries against Sakib's fon_analytics database (read-only).
// 15-minute cache lives server-side in Lambda memory.
//
// Shape returned:
//   {
//     generated_at: ISO string,
//     cache_age_seconds: number,
//     periods: {
//       yesterday | '7d' | '30d': {
//         revenue, orders, aov, revenue_prev, orders_prev
//       }
//     },
//     chart: [{ date, revenue, orders }, ...30 items chronological],
//     top_products: [{ title, sku, units, revenue }, ...up to 7],
//     recent_orders: [{ order_number, name, customer_email, total, currency,
//                       status, created_at, shipping_city, shipping_country }, ...up to 8]
//   }

const url = import.meta.env.VITE_AWS_SALES_SHOPIFY_URL;

export async function fetchSalesData(pin) {
  if (!url) {
    throw new Error('[salesData] VITE_AWS_SALES_SHOPIFY_URL not configured');
  }
  if (!pin) {
    throw new Error('Not logged in');
  }

  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pin }),
  });

  const body = await res.json().catch(() => ({ error: 'Invalid response' }));

  if (!res.ok) {
    throw new Error(body.error || `HTTP ${res.status}`);
  }

  return body.data;
}
